import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetFullURL } from "./../../CommonComponents/GlobalConfFiles/URLs";
import { useFetch } from "../../hooks/useFetch";
import OverviewInput from "../../CommonComponents/InitialInput/OverviewInput";
import OverviewButtons from "./Components/OverviewButtons";
import { LoadingScreen } from "../../CommonComponents/LoadingScreen/index";
import ListModal from "../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../CommonComponents/CircleButton";
import MessageLog from "../../CommonComponents/Messages/MessageLog";
import cardlogo from "../../Assets/cardLogo.svg";
import { useMessage } from "../../hooks/UseMessage";

function TestMethodOverview({ testMethodType }) {
  let navigate = useNavigate();

  const [testMethod, setTestMethod] = useState();
  const [showTestMethodList, setShowTestMethodList] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();

  const [_getTestMethodsList, _testMethodList, , , , , , _loadingtTestMethodList] =
    useFetch(GetFullURL("TestMethodList"), { method: "POST" });

  const [_getTestMethodExists, , , , , , , _loadingtTestMethodExist] = useFetch(
    GetFullURL("TestMethodExists"),
    { method: "POST" }
  );

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        break;
      case "error":
        _setErorMessages([]);
        break;
      case "warning":
      default:
        break;
    }
  }

  let buttonText;
  const operationLoading = _loadingtTestMethodExist || _loadingtTestMethodList;
  if (testMethodType) {
    buttonText = `List of ${testMethodType}s`;
  } else {
    buttonText = `List of Test Methods`;
  }

  return (
    // testMethod Overview here
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                  <img src={require("../../Assets/icon/partner.png")} className="img-fluid cardLogo" alt="" />
                  </span>
                  Test Method Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setTestMethod}
                    document={testMethod}
                    placeholder={`Test Method Id here`}
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={buttonText}
                    clickHandler={() => {
                      _getTestMethodsList(
                        {},
                        () => {
                          setShowTestMethodList(true);
                        }
                      );
                    }}
                  />
                  <OverviewButtons
                    testMethod={testMethod}
                    navigate={navigate}
                    _getTestMethodExists={_getTestMethodExists}
                    _createErrorMessage={_createErrorMessage}
                  />
                </div>
              </div>
            </div>
            <MessageLog
              errorMessages={[..._errorMessages]}
              successMessages={[]}
              warningMessages={[]}
              clearMessages={clearMessages}
            ></MessageLog>
            <div className="cardAlert"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ListModal
              setId={setTestMethod}
              dataList={_testMethodList}
              showListModal={showTestMethodList}
              setShowModal={setShowTestMethodList}
              title="List Of TestMethods"
              columns={[
                { field: "id", headerName: "Test Method ID", width: 250 },
                { field: "testMethodClassId", headerName: "Type", width: 250 },
                { field: "createdBy", headerName: "Created By", width: 350 },
              ]}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TestMethodOverview;
